import { RouteRecordRaw, createRouter, createWebHashHistory } from "vue-router";
import occRoutes from '../components/open-casting-call/routes';

const routes: RouteRecordRaw[] = [
    ...occRoutes,
]

export const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;
